import { ComboBoxCore } from './combo-box-core';
import { ComboBoxMenu } from './combo-box-menu';
import { ComboBoxProps } from './combo-box.types';
import { MenuItem } from '../filter-combo-box/filter-combo-box.types';

export const ComboBox = <T extends MenuItem>({ open = false, ...props }: ComboBoxProps<T>) => {
  return <ComboBoxCore {...props} open={open} menuElement={ComboBoxMenu} />;
};

export default ComboBox;
